import { useState } from "react";
import { getIngredientUnitLabel } from "../../../services/inventory/inventory.service";

export default function RecipeDetailOptionComponent({ option }) {
  const [ingredients, setIngredients] = useState(option.ingredients || []);

  return (
    <div className="flex items-start border border-px border-[#DADADA] min-h-[290px] bg-[#FFF6E8] mb-3">
      {/* ingredients */}
      <div className="w-[70%] bg-[#F8F8F8] min-h-[290px] pt-[27px] pl-[53px] pr-[42px] pb-[44px] border-r border-r-px border-r-[#DADADA]">
        {/* recipe ingredients items - list */}
        <div className="font-p_medium text-xs text-black leading-[13px] flex items-center space-x-[21px] mb-[7px]">
          <p className="w-[204px]">Ingredient</p>
          <p className="w-[70px]">Quantity</p>
          <p className="w-[123px]">Unit</p>
          <p className="w-[108px]">Cost (TK)</p>
        </div>

        {ingredients.map((item, idx) => (
          <div key={idx}>
            <div className="flex items-center space-x-[21px] mb-[15px]">
              <div className="w-[204px] h-[36px] rounded-[4px] text-sm text-[#828282] border border-px-[#D5D8DB] py-[8px] px-[15px] truncate">
                {item.ingredientName}
              </div>
              <div className="w-[70px] h-[36px] rounded-[4px] text-sm text-[#828282] border border-px-[#D5D8DB] py-[8px] text-center">
                {item.quantity}
              </div>
              <div className="w-[123px] h-[36px] rounded-[4px] text-sm text-[#828282] border border-px-[#D5D8DB] py-[8px] text-center">
                {getIngredientUnitLabel(item.recipeUnit)}
              </div>
              <div className="w-[108px] h-[36px] rounded-[4px] text-sm text-[#828282] border border-px-[#D5D8DB] py-[8px] text-center">
                {item.cost}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="w-[30%] min-h-[290px] pt-[32px] pl-[26px] pr-[39px]">
        <div
          className="flex items-center justify-between font-p_medium text-xs text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
        >
          <p>Ingredient Cost</p>
          <p>{option.ingredientCost}TK</p>
        </div>
        <div
          className="flex items-center justify-between font-p_medium text-xs text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
        >
          <p>Operational Cost</p>
          <p>{option.operationalCost}TK</p>
        </div>
        <div
          className="flex items-center justify-between font-p_medium text-xs text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
        >
          <p>Profit</p>
          <p>{option.profitAmount}TK</p>
        </div>
        <div
          className="flex items-center justify-between font-p_semibold text-sm text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
        >
          <p>Total Price</p>
          <p>{option.totalCost}TK</p>
        </div>
        <div
          className="flex items-center justify-between font-p_medium text-xs text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
        >
          <p>Discount</p>
          <p>{option.discountAmount}TK</p>
        </div>
        {/* {option.sellingPrice !== option.discountedPrice && (
          <div
            className="flex items-center justify-between font-p_semibold text-sm text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
          >
            <p>Discounted Price</p>
            <p>{option.discountedPrice}TK</p>
          </div>
        )} */}
        <div
          className="flex items-center justify-between font-p_semibold text-sm text-black leading-[13px] pb-[8.5px]
                border-b border-b-px border-b-[#DADADA] mb-[16.5px]"
        >
          <p>Selling Price</p>
          <p>{option.sellingPrice}TK</p>
        </div>
      </div>
    </div>
  );
}
